import baseAPI from '@/http'

const router = 'api/projeto/evidencia'

export const evidenceAPI = {
  create: (evidence) => baseAPI.post(router, evidence),
  update: (project) => baseAPI.put(router, project),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
}
